module.exports = __webpack_public_path__ + "static/landing-page-intro-7b1f729aabbb6c9288cbc19224cc5fda.mp4";